;(function () {
    /**
     * Quantity selectors in product hero, quick view, ajax cart
     * If its the ajax cart one, it will trigger the cart values to update when clicked too
     */
    document.addEventListener('click', async function (event) {
        if (event.target.classList.contains('js-qty-update')) {
            if (
                event.target.classList.contains('cart-qty') ||
                event.target.classList.contains('ajax-cart')
            ) {
                productAvailabliltyNotice = event.target
                    .closest('.cart-item')
                    .querySelector('.js-availability-notice ')
                productAvailablilty = productAvailabliltyNotice.querySelector(
                    '.js-availability-notice .js-availablilty'
                )
            } else {
                productAvailabliltyNotice = event.target
                    .closest('form[action="/cart/add"]')
                    ?.querySelector('.js-availability-notice ')
                productAvailablilty = productAvailabliltyNotice?.querySelector(
                    '.js-availability-notice .js-availablilty'
                )
            }
            var quantityField = event.target
                .closest('.qty-container')
                .querySelector('input')
            var quantity = parseInt(quantityField.value)
            let direction = 'increment'

            if (event.target.classList.contains('increase')) {
                quantity++
                direction = 'increment'
            } else if (
                event.target.classList.contains('decrease') &&
                quantity >= 1
            ) {
                quantity--
                direction = 'decrement'
            }

            quantityField.value = quantity

            // Availability notice
            if (
                productAvailablilty &&
                quantity > parseInt(productAvailablilty.textContent)
            ) {
                productAvailabliltyNotice.classList.remove('disabled')
            } else {
                productAvailabliltyNotice?.classList.add('disabled')
            }

            if (event.target.classList.contains('ajax-cart')) {
                /**
                 *
                 * If min/max buy limits are active, this checks to ensure you can add this to the cart
                 *
                 */
                if (window.enable_minmax_buys) {
                    let thisID = quantityField.closest('[data-id]').dataset.id
                    let thisHandle =
                        quantityField.closest('[data-handle]').dataset.handle
                    let formData = _createFormDataFromObject({
                        id: thisID,
                        handle: thisHandle,
                        quantity: direction == 'increment' ? 1 : -1,
                        direction: direction,
                    })

                    let canUpdate = await _canUpdateCart(formData)

                    if (canUpdate.amended) {
                        quantityField.value = canUpdate.amended
                    }
                }

                _ajaxUpdateCart(event.target)

                if (quantity == 0) {
                    let thisItem = event.target.closest('.cart-item')
                    if (thisItem) {
                        thisItem.remove()
                    }
                }
            }
        }
    })
})()
